import Vue from 'vue'
import Router from 'vue-router'
// const routerPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//     return routerPush.call(this, location).catch(error => error)
// }
import Layout from '@/layout'
//import index from '@/page/index'
import home from '@/page/home'
import manager from '@/page/manager'
import commission from '@/page/commission'
import shop from '@/page/shop'
import member from '@/page/member'
import announcement from '@/page/announcement'
import topup from '@/page/topup'
// import withdraw from '@/page/withdraw'
import record from '@/page/record'
import task from '@/page/task'
import order from '@/page/order'
import config from '@/page/config'
// import report from '@/page/report'
import swipe from '@/page/swipe'
import payOrder from '@/page/payOrder'
import swipeWithdraw from '@/page/swipeWithdraw'
import swipeRecord from '@/page/swipeRecord'
import feedbackOrder from '@/page/feedbackOrder'
import feedbackSwipe from '@/page/feedbackSwipe'
import praiseOrder from '@/page/praiseOrder'
// import managerReport from '@/page/managerReport'
// import assign from '@/page/assign'
// import swipeWithdrawPay from '@/page/swipeWithdrawPay'
import outsider from '@/page/outsider'
import withdrawalKanban from '@/page/withdrawalKanban'
import role from '@/page/role'
import ForRouter from '@/page/ForRouter'
// import arrangement from '@/page/arrangement'
import taskGroup from '@/page/taskGroup'
import receivable from '@/page/receivable'
import qqGroup from '@/page/qqGroup'
import category from '@/page/category'
import swipeCommissionTemplate from '@/page/swipeCommissionTemplate'
import swipeCommissionDetail from '@/page/swipeCommissionDetail'
import makeConfig from '@/page/makeConfig'
import orderReviewKanBan from '@/page/orderReviewKanBan'
import outsiderBill from '@/page/outsiderBill'
import reimbursement from '@/page/reimbursement'
import daily from '@/page/daily'
import taskOther from '@/page/taskOther'
import taskOtherOrder from '@/page/taskOtherOrder'
import memberData from '@/page/memberData'
import taskRelease from '@/page/taskRelease'

Vue.use(Router);


export const constantRoutes = [
        {
            path: '/',
            component: Layout,
            redirect: "/home",
            meta: {
                title: '红蓝圈-用户管理',
            },
            children:[
                {
                    path: '/home',
                    name: 'home',
                    component: home,
                    code:1,
                    meta: {
                        title: '红蓝圈-管理中心',
                        navtitle:'首页',
                        showInMenu: true
                    }
                },
                {
                    path: "memberManage",
                    name: "memberManage",
                    code: 2,
                    component: ForRouter,
                    meta: {
                        navtitle:'用户',
                        showInMenu: true
                    },
                    children:[
                        {
                            path: '/member',
                            name: 'member',
                            component: member,
                            code:42,
                            meta: {
                                title: '红蓝圈-用户列表',
                                navtitle:'用户列表',
                                showInMenu: true
                            }
                        },
                        {
                            path: '/memberData',
                            name: 'memberData',
                            component: memberData,
                            code:43,
                            meta: {
                                title: '红蓝圈-用户数据',
                                navtitle:'用户数据',
                                showInMenu: true
                            }
                        },
                    ]
                },
                {
                    path: '/shop',
                    name: 'shop',
                    component: shop,
                    code:3,
                    meta: {
                        title: '红蓝圈-店铺管理',
                        navtitle:'店铺',
                        showInMenu: true
                    }
                },
                {
                    path: '/swipe',
                    name: 'swipe',
                    component: swipe,
                    code:4,
                    meta: {
                        title: '红蓝圈-会员管理',
                        navtitle:'会员',
                        showInMenu: true
                    }
                },
                {
                    path: "taskManage",
                    name: "taskManage",
                    code: 5,
                    component: ForRouter,
                    meta: {
                        navtitle:'任务',
                        showInMenu: true
                    },
                    children:[
                        {
                            path: '/task',
                            name: 'task',
                            component: task,
                            code:51,
                            meta: {
                                title: '红蓝圈-任务管理',
                                navtitle:'任务列表',
                                showInMenu: true
                            }
                        },
                        {
                            path: '/taskRelease',
                            name: 'taskRelease',
                            component: taskRelease,
                            code:52,
                            meta: {
                                title: '红蓝圈-任务管理',
                                navtitle:'任务外放',
                                showInMenu: true
                            }
                        },
                    ]
                },
                {
                    path: '/taskGroup',
                    name: 'taskGroup',
                    component: taskGroup,
                    code:6,
                    meta: {
                        title: '红蓝圈-排单',
                        navtitle:'排单',
                        showInMenu: true
                    }
                },
                {
                    path: '/order',
                    name: 'order',
                    component: order,
                    code:10,
                    meta: {
                        title: '红蓝圈-订单管理',
                        navtitle:'订单',
                        showInMenu: true
                    }
                },
                {
                    path: '/orderReviewKanBan',
                    name: 'orderReviewKanBan',
                    component: orderReviewKanBan,
                    code:37,
                    meta: {
                        title: '红蓝圈-订单审核看板',
                        navtitle:'订单审核看板',
                        showInMenu: true
                    }
                },
                {
                    path: '/praiseOrder',
                    name: 'praiseOrder',
                    component: praiseOrder,
                    code:11,
                    meta: {
                        title: '红蓝圈-好评订单',
                        navtitle:'好评',
                        showInMenu: true
                    }
                },
                {
                    path: "feedback",
                    name: "feedback",
                    code: 12,
                    component: ForRouter,
                    meta: {
                        navtitle:'反馈',
                        showInMenu: true
                    },
                    children:[
                        {
                            path: '/feedbackOrder',
                            name: 'feedbackOrder',
                            component: feedbackOrder,
                            code:13,
                            meta: {
                                title: '红蓝圈-订单反馈',
                                navtitle:'订单反馈',
                                showInMenu: true
                            }
                        },
                        {
                            path: '/feedbackSwipe',
                            name: 'feedbackSwipe',
                            component: feedbackSwipe,
                            code:14,
                            meta: {
                                title: '红蓝圈-会员反馈',
                                navtitle:'会员反馈',
                                showInMenu: true
                            }
                        },
                    ]
                },
                {
                    path: '/topup',
                    name: 'topup',
                    component: topup,
                    code:16,
                    meta: {
                        title: '红蓝圈-充值/提现',
                        navtitle:'充值/提现',
                        showInMenu: true
                    }
                },
                {
                    path: "finance",
                    name: "finance",
                    code: 15,
                    component: ForRouter,
                    meta: {
                        navtitle:'财务',
                        showInMenu: true
                    },
                    children:[
                        // {
                        //     path: '/withdraw',
                        //     name: 'withdraw',
                        //     component: withdraw,
                        //     code:17,
                        //     meta: {
                        //         title: '红蓝圈-提现审核',
                        //         navtitle:'提现审批',
                        //         showInMenu: true
                        //     }
                        // },
                        {
                            path: '/record',
                            name: 'record',
                            component: record,
                            code:18,
                            meta: {
                                title: '红蓝圈-资金流水',
                                navtitle:'资金流水',
                                showInMenu: true
                            }
                        },
                        {
                            path: '/payOrder',
                            name: 'payOrder',
                            component: payOrder,
                            code:19,
                            meta: {
                                title: '红蓝圈-本金打款',
                                navtitle:'本金打款',
                                showInMenu: true
                            }
                        },
                        {
                            path: '/swipeWithdraw',
                            name: 'swipeWithdraw',
                            component: swipeWithdraw,
                            code:20,
                            meta: {
                                title: '红蓝圈-会员提现',
                                navtitle:'会员提现',
                                showInMenu: true
                            }
                        },
                        {
                            path: '/withdrawalKanban',
                            name: 'withdrawalKanban',
                            component: withdrawalKanban,
                            code:21,
                            meta: {
                                title: '红蓝圈-会员提现看板',
                                navtitle:'会员提现看板',
                                showInMenu: true
                            }
                        }, 
                        {
                            path: '/swipeRecord',
                            name: 'swipeRecord',
                            component: swipeRecord,
                            code:22,
                            meta: {
                                title: '红蓝圈-会员资金',
                                navtitle:'会员资金',
                                showInMenu: true
                            }
                        },
                        {
                            path: '/outsiderBill',
                            name: 'outsiderBill',
                            component: outsiderBill,
                            code:45,
                            meta: {
                                title: '红蓝圈-兼职资金',
                                navtitle:'兼职资金',
                                showInMenu: true
                            }
                        },
                        // {
                        //     path: '/managerReport',
                        //     name: 'managerReport',
                        //     component: managerReport,
                        //     code:23,
                        //     meta: {
                        //         title: '红蓝圈-绩效报表',
                        //         navtitle:'绩效报表',
                        //         showInMenu: true
                        //     }
                        // },
                        {
                            path: '/receivable',
                            name: 'receivable',
                            component: receivable,
                            code:23,
                            meta: {
                                title: '红蓝圈-应收/余额',
                                navtitle:'应收余额',
                                showInMenu: true
                            }
                        }
                    ]
                },
                // {
                //     path: '/swipeWithdrawPay',
                //     name: 'swipeWithdrawPay',
                //     component: swipeWithdrawPay,
                //     code:24,
                //     meta: {
                //         title: '红蓝圈-会员提现打款',
                //         navtitle:'会员提现打款',
                //         showInMenu: true
                //     }
                // },
                {
                    path: '/outsider',
                    name: 'outsider',
                    component: outsider,
                    code:25,
                    meta: {
                        title: '红蓝圈-兼职',
                        navtitle:'兼职',
                        showInMenu: true
                    }
                }, 
                {
                    path: '/reimbursement',
                    name: 'reimbursement',
                    component: reimbursement,
                    code:44,
                    meta: {
                        title: '红蓝圈-线下支出',
                        navtitle:'线下支出',
                        showInMenu: true
                    }
                },
                {
                    path: '/daily',
                    name: 'daily',
                    component: daily,
                    code:38,
                    meta: {
                        title: '红蓝圈-日报',
                        navtitle:'日报',
                        showInMenu: true
                    }
                },
                // {
                //     path: '/taskOther',
                //     name: 'taskOther',
                //     component: taskOther,
                //     code:39,
                //     meta: {
                //         title: '红蓝圈-其它任务',
                //         navtitle:'其它任务',
                //         showInMenu: true
                //     }
                // },
                {
                    path: "more",
                    name: "more",
                    code: 39,
                    component: ForRouter,
                    meta: {
                        navtitle:'更多任务',
                        showInMenu: true
                    },
                    children:[
                        {
                            path: '/taskOther',
                            name: 'taskOther',
                            component: taskOther,
                            code:40,
                            meta: {
                                title: '红蓝圈-任务管理',
                                navtitle:'任务管理',
                                showInMenu: true
                            }
                        },
                        {
                            path: '/taskOtherOrder',
                            name: 'taskOtherOrder',
                            component: taskOtherOrder,
                            code:41,
                            meta: {
                                title: '红蓝圈-任务审核',
                                navtitle:'任务审核',
                                showInMenu: true
                            }
                        },
                    ]
                },
                {
                    path: "system",
                    name: "system",
                    code: 26,
                    component: ForRouter,
                    meta: {
                        navtitle:'系统',
                        showInMenu: true
                    },
                    children:[
                        {
                            path: '/manager',
                            name: 'manager',
                            component: manager,
                            code:27,
                            meta: {
                                title: '红蓝圈-人员管理',
                                navtitle:'人员管理',
                                showInMenu: true
                            }
                        },
                        {
                            path: '/commission',
                            name: 'commission',
                            component: commission,
                            code:28,
                            meta: {
                                title: '红蓝圈-佣金模板',
                                navtitle:'佣金模板',
                                showInMenu: true
                            }
                        },
                        {
                            path: '/announcement',
                            name: 'announcement',
                            component: announcement,
                            code:29,
                            meta: {
                                title: '红蓝圈-公告管理',
                                navtitle:'公告管理',
                                showInMenu: true
                            }
                        },
                        {
                            path: '/config',
                            name: 'config',
                            component: config,
                            code:30,
                            meta: {
                                title: '红蓝圈-系统配置',
                                navtitle:'系统配置',
                                showInMenu: true
                            }
                        },
                        {
                            path: '/role',
                            name: 'role',
                            component: role,
                            code:31,
                            meta: {
                                title: '红蓝圈-角色管理',
                                navtitle:'角色管理',
                                showInMenu: true
                            }
                        },
                        {
                            path: '/qqGroup',
                            name: 'qqGroup',
                            component: qqGroup,
                            code:32,
                            meta: {
                                title: '红蓝圈-QQ群管理',
                                navtitle:'QQ群管理',
                                showInMenu: true
                            }
                        },
                        {
                            path: '/category',
                            name: 'category',
                            component: category,
                            code:33,
                            meta: {
                                title: '红蓝圈-店铺栏目管理',
                                navtitle:'店铺栏目管理',
                                showInMenu: true
                            }
                        },
                        {
                            path: '/swipeCommissionTemplate',
                            name: 'swipeCommissionTemplate',
                            component: swipeCommissionTemplate,
                            code:34,
                            meta: {
                                title: '红蓝圈-会员佣金配置',
                                navtitle:'会员佣金配置',
                                showInMenu: true
                            }
                        },
                        {
                            path: '/swipeCommissionDetail',
                            name: 'swipeCommissionDetail',
                            component: swipeCommissionDetail,
                            code:35,
                            meta: {
                                title: '红蓝圈-会员佣金明细配置',
                                navtitle:'会员佣金明细配置',
                                showInMenu: false
                            }
                        }
                        ,
                        {
                            path: '/makeConfig',
                            name: 'makeConfig',
                            component: makeConfig,
                            code:36,
                            meta: {
                                title: '红蓝圈-上限配置',
                                navtitle:'上限配置',
                                showInMenu: false
                            }
                        }
                    ]
                }
            ]
        }
        
        
        // {
        //     path: '/report',
        //     name: 'report',
        //     component: report,
        //     meta: {
        //         title: '红蓝圈-财务报表'
        //     }
        // },     
    ]

    const createRouter = () => new Router({
        routes: constantRoutes
      })
      
      const router = createRouter()
      
      
      export default router

